module.exports = __webpack_public_path__ + "img/Delete(Button).e5de5f34.svg";